/**
 * Flattens the nested sidebarConfig into a flat array of searchable items.
 * Each item has: { label, settingName, group, normalizedText }
 * normalizeText is pre-calculated to speed up filtering.
 * Buttons are skipped.
 */
export const flattenSidebarConfig = (sidebarConfig, group = '') => {
    const items = [];

    for (const item of sidebarConfig) {
        if (item.isButton) continue;

        if (item.isAccordion) {
            const childItems = flattenSidebarConfig(item.settings || [], item.label);
            items.push(...childItems);
        } else if (item.settingName) {
            const label = item.label || '';
            const settingName = item.settingName || '';
            const groupName = group || '';

            items.push({
                label,
                settingName,
                group: groupName,
                normalizedText: `${label} ${groupName} ${settingName}`.toLowerCase()
            });
        }
    }

    return items;
};

/**
 * Filters flat items by checking if all query tokens exist in the pre-calculated normalizedText.
 */
export const filterItems = (items, query) => {
    if (!query || !query.trim()) return items;

    const queryTokens = query.toLowerCase().trim().split(/\s+/).filter(Boolean);

    return items.filter((item) => {
        const normalizedText = item.normalizedText || '';
        return queryTokens.every((token) => normalizedText.includes(token));
    });
};
